import React, { useEffect, useState } from "react";
import { Logo } from "assets/svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { cleanDataRegister, fetchCheckToken } from "reducers/registerSlice";

const EmailVerified: React.FC = () => {
  const [type, setType] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { verifyData, errorVerify } = useSelector(
    (state: RootState) => state.register,
  );

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      dispatch(fetchCheckToken(token));
    }
  }, [token]);

  useEffect(() => {
    if (verifyData) {
      setType(verifyData.data.type);
    }

    if (errorVerify) {
      navigate(`/link-invalid?type=${errorVerify.type}`);
    }

    dispatch(cleanDataRegister());
  }, [verifyData, errorVerify]);

  // Auto-redirect after 10 seconds to the same URL as the Link
  useEffect(() => {
    if (!token || !type) return;
    const targetUrl = `/information?token=${token}&type=${type}`;
    const timer = setTimeout(() => {
      navigate(targetUrl);
    }, 10000);
    return () => clearTimeout(timer);
  }, [token, type, navigate]);

  return (
    <main className="bg--blur box">
      <div
        className="w-full mt-[60px] relative rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] text-center not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          メールアドレスの認証が <br />
          完了しました
        </h2>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[10px]">
          ご登録ありがとうございます。 <br />
          メールアドレスの確認が完了しました。
        </p>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[15px]">
          引き続き、企業情報を入力して <br />
          本登録を完了してください。
        </p>

        <Link
          to={`/information?token=${token}&type=${type}`}
          className="w-full py-[10px] px-[20px] font-bold bg-primary text-white rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px] text-center"
        >
          本登録へ進む
        </Link>

        <p className="text-[11px] sm:text-[12px] font-normal leading-[160%] text-center mb-[30px]">
          ※自動的に10秒後に本登録ページに遷移します。
        </p>
      </div>
    </main>
  );
};

export default EmailVerified;
